/* PetXio — Nature & Play
   Interacciones y animaciones vanilla.
   ------------------------------------------------------------------------- */

(function () {
  'use strict';

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------------- Reveal on scroll (IntersectionObserver compartido) ---
  function initReveals() {
    const els = document.querySelectorAll('.mt-reveal:not(.mt-in)');
    if (!els.length) return;
    if (prefersReduced || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('mt-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    els.forEach((el) => io.observe(el));
  }

  // ---------------- Marquee: duplica contenido para loop sin fin ---------
  function initMarquees() {
    document.querySelectorAll('.mt-marquee__track:not([data-dup])').forEach((track) => {
      const clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      const parent = track.parentNode;
      const wrap = document.createElement('div');
      wrap.className = 'mt-marquee__track';
      // Duplicamos los hijos dentro del mismo track para que el keyframe -50% funcione
      const kids = Array.from(track.children).map((n) => n.cloneNode(true));
      kids.forEach((n) => {
        n.setAttribute('aria-hidden', 'true');
        track.appendChild(n);
      });
      track.setAttribute('data-dup', '1');
    });
  }

  // ---------------- Producto: galería, variantes, cantidad ---------------
  function initProductGallery() {
    const gallery = document.querySelector('[data-mt-gallery]');
    if (!gallery) return;
    const mainImg = gallery.querySelector('.mt-product__gallery-main img');
    const thumbs = gallery.querySelectorAll('.mt-product__thumb');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-src');
        if (mainImg && src) {
          mainImg.src = src;
          mainImg.style.opacity = '0';
          requestAnimationFrame(() => { mainImg.style.transition = 'opacity 240ms'; mainImg.style.opacity = '1'; });
        }
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  function initProductPills() {
    const root = document.querySelector('[data-mt-options-root]');
    if (!root) {
      // Fallback for demo without product: just toggle visual state
      document.querySelectorAll('[data-mt-option]').forEach((group) => {
        group.querySelectorAll('.mt-product__pill').forEach((pill) => {
          pill.addEventListener('click', () => {
            group.querySelectorAll('.mt-product__pill').forEach((p) => p.classList.remove('is-active'));
            pill.classList.add('is-active');
          });
        });
      });
      return;
    }

    const blob = root.querySelector('script[data-mt-variants]');
    let variants = [];
    try { variants = JSON.parse(blob.textContent); } catch (e) { return; }
    if (!variants.length) return;

    const groups = [...root.querySelectorAll('[data-mt-option]')];
    const getSelection = () => groups.map((g) => {
      const active = g.querySelector('.mt-product__pill.is-active');
      return active ? active.dataset.optionValue : null;
    });

    const findVariant = (sel) => variants.find((v) =>
      v.options.length === sel.length && v.options.every((o, i) => o === sel[i])
    );

    const priceNow    = document.querySelector('[data-mt-price-now]');
    const priceWas    = document.querySelector('[data-mt-price-was]');
    const priceSave   = document.querySelector('[data-mt-price-save]');
    const variantIn   = document.querySelector('[data-mt-variant-id]');
    const addBtn      = document.querySelector('[data-mt-add-btn]');
    const stickyNow   = document.querySelector('[data-mt-sticky-now]');
    const stickyWas   = document.querySelector('[data-mt-sticky-was]');
    const stickyId    = document.querySelector('[data-mt-sticky-variant-id]');
    const stickyBtn   = document.querySelector('[data-mt-sticky-btn]');
    const saveLabel   = priceSave ? (priceSave.textContent.match(/^\S+/) || ['Ahorra'])[0] : 'Ahorra';

    const parseMoney = (s) => {
      if (!s) return 0;
      const n = String(s).replace(/[^\d,.-]/g, '').replace(',', '.');
      return parseFloat(n) || 0;
    };

    const applyVariant = (v) => {
      if (!v) return;
      if (variantIn) variantIn.value = v.id;
      if (stickyId)  stickyId.value  = v.id;
      if (priceNow)  priceNow.textContent = v.price;
      if (stickyNow) stickyNow.textContent = v.price;
      const hasWas = v.compare_at_price && parseMoney(v.compare_at_price) > parseMoney(v.price);
      if (priceWas) {
        if (hasWas) { priceWas.textContent = v.compare_at_price; priceWas.hidden = false; }
        else { priceWas.hidden = true; }
      }
      if (stickyWas) {
        if (hasWas) { stickyWas.textContent = v.compare_at_price; stickyWas.hidden = false; }
        else { stickyWas.hidden = true; }
      }
      if (priceSave) {
        if (hasWas) {
          const pct = Math.round((parseMoney(v.compare_at_price) - parseMoney(v.price)) / parseMoney(v.compare_at_price) * 100);
          priceSave.textContent = saveLabel + ' ' + pct + '%';
          priceSave.hidden = false;
        } else priceSave.hidden = true;
      }
      const setBtn = (btn) => {
        if (!btn) return;
        btn.disabled = !v.available;
        if (btn.dataset.buyText && btn.dataset.soldText) {
          const newLabel = v.available ? btn.dataset.buyText : btn.dataset.soldText;
          const labelSpan = btn.querySelector('[data-mt-btn-label]');
          if (labelSpan) { labelSpan.textContent = newLabel; }
          else { btn.textContent = newLabel; }
        }
      };
      setBtn(addBtn);
      setBtn(stickyBtn);
      // Update URL non-destructively
      try {
        const url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      } catch (e) {}
    };

    groups.forEach((group) => {
      group.querySelectorAll('.mt-product__pill').forEach((pill) => {
        pill.addEventListener('click', () => {
          group.querySelectorAll('.mt-product__pill').forEach((p) => p.classList.remove('is-active'));
          pill.classList.add('is-active');
          const v = findVariant(getSelection());
          applyVariant(v);
        });
      });
    });

    // If URL has ?variant=N, sync UI to it
    const urlVariant = new URLSearchParams(location.search).get('variant');
    if (urlVariant) {
      const v = variants.find((x) => String(x.id) === String(urlVariant));
      if (v) {
        groups.forEach((g, i) => {
          const val = v.options[i];
          g.querySelectorAll('.mt-product__pill').forEach((p) => {
            p.classList.toggle('is-active', p.dataset.optionValue === val);
          });
        });
        applyVariant(v);
      }
    }
  }

  function initQty() {
    document.querySelectorAll('.mt-product__qty').forEach((box) => {
      const input = box.querySelector('input');
      const minus = box.querySelector('[data-qty-minus]');
      const plus  = box.querySelector('[data-qty-plus]');
      if (!input) return;
      minus && minus.addEventListener('click', () => {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      plus && plus.addEventListener('click', () => {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  }

  // ---------------- Slider comparador Antes / Después --------------------
  function initBeforeAfter() {
    document.querySelectorAll('[data-mt-ba]').forEach((stage) => {
      const range  = stage.querySelector('[data-mt-ba-range]');
      const handle = stage.querySelector('[data-mt-ba-handle]');
      if (!range || !handle) return;

      const setPos = (pct) => {
        const p = Math.max(0, Math.min(100, pct));
        stage.style.setProperty('--mt-ba-pos', p + '%');
        stage.style.setProperty('--mt-ba-pct', p);
        range.value = p;
      };

      setPos(parseFloat(range.value) || 50);

      range.addEventListener('input', () => setPos(parseFloat(range.value)));

      const startDrag = (clientX) => {
        const rect = stage.getBoundingClientRect();
        const pct = ((clientX - rect.left) / rect.width) * 100;
        setPos(pct);
      };
      let dragging = false;
      const onMove = (e) => {
        if (!dragging) return;
        const x = e.touches ? e.touches[0].clientX : e.clientX;
        startDrag(x);
      };
      const onUp = () => { dragging = false; document.body.style.cursor = ''; };

      handle.addEventListener('pointerdown', (e) => {
        dragging = true;
        document.body.style.cursor = 'ew-resize';
        try { handle.setPointerCapture(e.pointerId); } catch (_) {}
        startDrag(e.clientX);
      });
      stage.addEventListener('pointerdown', (e) => {
        if (e.target === range) return;
        dragging = true;
        document.body.style.cursor = 'ew-resize';
        startDrag(e.clientX);
      });
      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp);
      window.addEventListener('pointercancel', onUp);

      // Auto-play animation al aparecer en viewport (una sola vez)
      if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let played = false;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting || played || dragging) return;
          played = true;
          const startPos = parseFloat(range.value) || 50;
          const sequence = [
            { to: 10,  dur: 900 },
            { to: 90,  dur: 1400 },
            { to: startPos, dur: 1000 }
          ];
          let idx = 0;
          const animateStep = () => {
            const step = sequence[idx];
            if (!step) return;
            const from = parseFloat(range.value) || 50;
            const start = performance.now();
            const ease = (t) => t < 0.5 ? 2*t*t : -1 + (4 - 2*t) * t;
            const frame = (now) => {
              if (dragging) return;
              const t = Math.min(1, (now - start) / step.dur);
              setPos(from + (step.to - from) * ease(t));
              if (t < 1) requestAnimationFrame(frame);
              else { idx++; setTimeout(animateStep, 200); }
            };
            requestAnimationFrame(frame);
          };
          setTimeout(animateStep, 300);
          io.disconnect();
        });
      }, { threshold: 0.4 });
      io.observe(stage);
    });

    // Counter animation en los stats
    document.querySelectorAll('.mt-ba__stats').forEach((wrap) => {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const nums = wrap.querySelectorAll('.mt-ba__stat-num');
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          nums.forEach((el) => {
            const raw = el.textContent.trim();
            const m = raw.match(/^(\d+)(.*)$/);
            if (!m) return;
            const target = parseInt(m[1], 10);
            const suffix = m[2];
            if (target <= 0) return;
            const dur = 1400;
            const start = performance.now();
            const frame = (now) => {
              const t = Math.min(1, (now - start) / dur);
              const val = Math.round(target * (t < 0.5 ? 2*t*t : -1 + (4 - 2*t) * t));
              el.textContent = val + suffix;
              if (t < 1) requestAnimationFrame(frame);
            };
            requestAnimationFrame(frame);
          });
          io.disconnect();
        });
      }, { threshold: 0.6 });
      io.observe(wrap);
    });
  }

  // ---------------- Popup de bienvenida (10% off) ------------------------
  function initWelcomePopup() {
    const pop = document.querySelector('[data-mt-pop]');
    if (!pop) return;
    const STORAGE_KEY = 'mt-welcome-popup-v1';
    // Skip if user already dismissed/completed
    try { if (localStorage.getItem(STORAGE_KEY) === 'done') return; } catch (_) {}
    // Skip inside Shopify's design mode (editor) — always visible would annoy the merchant
    if (window.Shopify && window.Shopify.designMode) return;

    const delay = Math.max(0, parseFloat(pop.getAttribute('data-delay')) || 4) * 1000;
    const code  = pop.getAttribute('data-code') || 'WELCOME10';
    const formCard    = pop.querySelector('[data-mt-pop-form]');
    const successCard = pop.querySelector('[data-mt-pop-success]');
    const formEl      = pop.querySelector('[data-mt-pop-formEl]');
    const submitBtn   = pop.querySelector('.mt-pop__submit');
    const errorEl     = pop.querySelector('[data-mt-pop-error]');

    const open  = () => { pop.classList.add('is-open'); pop.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
    const close = (markDone) => {
      pop.classList.remove('is-open');
      pop.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (markDone) { try { localStorage.setItem(STORAGE_KEY, 'done'); } catch (_) {} }
    };

    // Open after delay
    setTimeout(open, delay);

    // Close handlers
    pop.querySelectorAll('[data-mt-pop-close]').forEach((el) => {
      el.addEventListener('click', () => close(true));
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && pop.classList.contains('is-open')) close(true);
    });

    // Submit form
    if (formEl) {
      formEl.addEventListener('submit', async (e) => {
        e.preventDefault();
        errorEl.hidden = true;
        const email = (formEl.querySelector('input[name=email]').value || '').trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          errorEl.textContent = 'Please enter a valid email.';
          errorEl.hidden = false;
          return;
        }
        submitBtn.classList.add('is-loading');
        submitBtn.disabled = true;

        // Submit to Shopify customer form endpoint (tags customer as newsletter subscriber)
        const fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('contact[email]', email);
        fd.append('contact[tags]', 'newsletter,welcome-popup');
        fd.append('contact[accepts_marketing]', 'true');

        try {
          await fetch('/contact#contact_form', {
            method: 'POST',
            body: fd,
            credentials: 'same-origin',
            mode: 'no-cors'
          });
        } catch (_) {
          // Even on network error, we still show the code — user's email may have arrived server-side
        }

        // Show success state (do this regardless — the code exists as a Shopify discount)
        formCard.hidden = true;
        successCard.hidden = false;
        try { localStorage.setItem(STORAGE_KEY, 'done'); } catch (_) {}
      });
    }

    // Copy code
    const copyBtn = pop.querySelector('[data-mt-pop-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(code);
          copyBtn.classList.add('is-copied');
          const txt = copyBtn.querySelector('[data-mt-pop-copy-txt]');
          if (txt) { const old = txt.textContent; txt.textContent = 'Copied!'; setTimeout(() => { txt.textContent = old; copyBtn.classList.remove('is-copied'); }, 2000); }
        } catch (_) {
          // Clipboard API can fail on non-HTTPS — select as fallback
          const span = pop.querySelector('[data-mt-pop-code-val]');
          if (span) {
            const r = document.createRange(); r.selectNodeContents(span);
            const s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
          }
        }
      });
    }
  }

  // ---------------- Auto-clic en el detalle FAQ (uno abierto a la vez) --
  function initFaqSingle() {
    document.querySelectorAll('[data-mt-faq]').forEach((wrap) => {
      const items = wrap.querySelectorAll('details.mt-faq__item');
      items.forEach((d) => {
        d.addEventListener('toggle', () => {
          if (d.open) items.forEach((o) => { if (o !== d) o.open = false; });
        });
      });
    });
  }

  function initAddOn() {
    const form = document.querySelector('[data-mt-product-form]');
    if (!form) return;

    const qtyInput   = document.querySelector('.mt-product__qty input[name="quantity"]');
    const qtyHidden  = form.querySelector('[data-mt-qty-hidden]');

    // Sync visible qty input to hidden items[0][quantity]
    const syncQty = () => {
      if (qtyInput && qtyHidden) qtyHidden.value = parseInt(qtyInput.value, 10) || 1;
    };
    if (qtyInput) {
      qtyInput.addEventListener('input', syncQty);
      qtyInput.addEventListener('change', syncQty);
    }
    document.querySelectorAll('.mt-product__qty [data-qty-minus], .mt-product__qty [data-qty-plus]').forEach(btn => {
      btn.addEventListener('click', () => setTimeout(syncQty, 10));
    });
    syncQty();

    // Support multiple addons (each keyed by data-mt-addon-wrap="a" | "b")
    document.querySelectorAll('[data-mt-addon-wrap]').forEach(wrap => {
      const key = wrap.dataset.mtAddonWrap || 'a';
      const checkbox = wrap.querySelector(`[data-mt-addon-checkbox="${key}"], [data-mt-addon-checkbox]`);
      const inputs = form.querySelectorAll(`[data-mt-addon-input="${key}"]`);
      if (!checkbox || !inputs.length) return;
      const apply = () => {
        wrap.classList.toggle('is-active', checkbox.checked);
        inputs.forEach(i => { i.disabled = !checkbox.checked; });
      };
      checkbox.addEventListener('change', apply);
      apply();
    });
  }

  function initHeroSlider() {
    document.querySelectorAll('[data-mt-hero-slider]').forEach(slider => {
      const slides = Array.from(slider.querySelectorAll('.mt-hero__slide'));
      if (slides.length < 2) return;
      const dots = Array.from(slider.querySelectorAll('[data-mt-slider-dot]'));
      const prevBtn = slider.querySelector('[data-mt-slider-prev]');
      const nextBtn = slider.querySelector('[data-mt-slider-next]');
      const delay = parseInt(slider.dataset.autoplay, 10) || 5000;
      const heroContent = document.querySelector('.mt-hero__content');
      let idx = 0, timer = null;

      const slideData = {};
      slider.querySelectorAll('[data-mt-slide-data]').forEach(sd => {
        try { slideData[sd.dataset.mtSlideData] = JSON.parse(sd.textContent); } catch(e){}
      });

      const applyContent = i => {
        if (!heroContent || !slideData[i]) return;
        const d = slideData[i];
        if (d.headline) { const t = heroContent.querySelector('.mt-hero__title'); if (t) t.textContent = d.headline; }
        if (d.body)     { const b = heroContent.querySelector('.mt-hero__body');  if (b) b.innerHTML = d.body.replace(/\n/g,'<br>'); }
        if (d.eyebrow)  { const e = heroContent.querySelector('.mt-hero__eyebrow'); if (e) { const svg = e.querySelector('svg'); e.textContent = ' ' + d.eyebrow; if (svg) e.prepend(svg); } }
        if (d.ctaText)  { const c = heroContent.querySelector('.mt-hero__ctas .mt-btn--primary'); if (c) { const svg = c.querySelector('svg'); c.textContent = d.ctaText + ' '; if (svg) c.appendChild(svg); if (d.ctaUrl) c.setAttribute('href', d.ctaUrl); } }
      };

      const goTo = i => {
        idx = (i + slides.length) % slides.length;
        slides.forEach((s, n) => s.classList.toggle('is-active', n === idx));
        dots.forEach((d, n) => d.classList.toggle('is-active', n === idx));
        applyContent(idx);
      };
      const next = () => goTo(idx + 1);
      const prev = () => goTo(idx - 1);
      const restart = () => { if (timer) clearInterval(timer); timer = setInterval(next, delay); };

      dots.forEach(d => d.addEventListener('click', () => { goTo(parseInt(d.dataset.mtSliderDot, 10)); restart(); }));
      if (prevBtn) prevBtn.addEventListener('click', () => { prev(); restart(); });
      if (nextBtn) nextBtn.addEventListener('click', () => { next(); restart(); });

      // Swipe touch mobile
      let sx = 0, sy = 0;
      slider.addEventListener('touchstart', e => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      slider.addEventListener('touchend', e => {
        const dx = e.changedTouches[0].clientX - sx;
        const dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) next(); else prev();
          restart();
        }
      });

      // Pause on hover (desktop)
      slider.addEventListener('mouseenter', () => { if (timer) clearInterval(timer); });
      slider.addEventListener('mouseleave', restart);

      restart();
    });
  }

  function bootAll() {
    initReveals();
    initMarquees();
    initProductGallery();
    initProductPills();
    initQty();
    initFaqSingle();
    initBeforeAfter();
    initWelcomePopup();
    initAddOn();
    initHeroSlider();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();
